import { Component, Input } from '@angular/core';
import { IconModule } from '@rogers/cdk/icon';
import { CommonModule } from '@angular/common';
import { HighlightDirective } from '../utils/highlight.directive';
import { ButtonComponent } from '../button/button.component';

@Component({
  standalone: true,
  imports: [IconModule, CommonModule, HighlightDirective, ButtonComponent],
  selector: 'ucx-system-message',
  templateUrl: './system-message.component.html',
  styleUrls: ['./system-message.component.scss'],
})
export class SystemMessageComponent {
  @Input() messageTitle = '';
  @Input() isFullHeight = false;
  @Input() isSystemFeedbackSuccess = false;
  @Input() isSystemFeedbackError = false;
  @Input() systemFeedbackAltText = '';
  @Input() cardText = '';
  @Input() queuePosition = '';
  @Input() estimatedTime = '';
  @Input() bigIcon = '';
  @Input() bigIconAltText = '';
  @Input() cannedResponses = [];
  @Input() onCannedResponseClick;
  @Input() rippleEffect = false;
  @Input() whixScore = -1;

  cannedResponseClick = (response): void => {
    this.onCannedResponseClick(response);
  };
}
